import { v4 as uuid } from 'uuid';

const trackingStore = {
  resourceId: null,
  sessionId: uuid(),
  resourceUrl: null,
};

export default trackingStore;
